import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import decimalHint from 'scaleflow/utils/decimal-hint';

export default class BusinessMetricsCreateController extends Controller {
  @tracked activeStep = 0;
  @tracked metricChangeset = {};
  @tracked targetChangeset = {};
  @tracked selectedGoals = [];
  @tracked goalSearch = '';
  @tracked isSaving = false;
  @tracked isAdvancedOpen = false;

  @service betaToggle;
  @service store;
  @service router;

  @action
  setActiveStep(index) {
    this.activeStep = index;
  }

  @action
  toggleAdvanced() {
    this.isAdvancedOpen = !this.isAdvancedOpen;
  }

  @action
  decimalHint(val) {
    return decimalHint(val, Number(this.metricChangeset.decimals));
  }

  get goals() {
    return this.store.peekAll('goal');
  }

  @action
  onDescriptionChange(changeset, e) {
    changeset.set('description', e);
  }

  @action
  async saveMetric() {
    this.isSaving = true;
    try {
      this.metricChangeset.changes.forEach((change) => {
        this.model.set(change.key, change.value);
      });
      await this.model.save();
      for (let i = 0; i < this.selectedGoals.length; i++) {
        const target = this.store.createRecord('target', {
          target_value: this.targetChangeset.target_value,
          end_date: this.targetChangeset.end_date,
          goal: this.selectedGoals[i],
          metric: this.model,
        });
        await target.save();
      }
      this.goToListPage();
    } finally {
      this.isSaving = false;
    }
  }

  @action
  handleGoalsSelect(goal, e) {
    const checked = e.target.checked;
    if (checked === undefined) return;
    const goals = this.selectedGoals;
    if (checked) goals.push(goal);
    else {
      const index = goals.findIndex((_goal) => _goal.id === goal.id);
      if (index < 0) return;
      else goals.splice(index, 1);
    }
    this.selectedGoals = goals;
  }

  @action
  rollbackChanges(changeset) {
    if (!changeset) {
      this.metricChangeset.rollback();
      this.targetChangeset.rollback();
    } else changeset.rollback();
  }

  @action
  goToListPage() {
    this.router.transitionTo('business.metrics');
  }

  @action
  onFormCancel() {
    this.rollbackChanges();
    this.model.deleteRecord();
    this.goToListPage();
  }
}
